import { useContext, useState } from "react";

import { isAPIError } from "lib/api/base";
import { Subscription } from "lib/api/subscription";

import { CheckoutContext } from "contexts/CheckoutProvider";

import StepLayoutLoadingScreen from "components/Step/StepLayoutLoadingScreen";
import StepThemePreferences from "components/Step/StepThemePreferences";
import { ThemePreferenceSubmit } from "components/Step/stepTypes";

import {
  MembershipState,
  MembershipStep,
} from "components/Membership/membershipTypes";
import { completeGSUQuiz } from "components/Membership/membershipUtil";

import { trackGiftSubscriptionActivated } from "components/Redeem/analytics";

export const MembershipStepThemePreferences = ({
  routePrevStep,
  ...state
}: MembershipState) => {
  const backButtonProps = {
    onClick: () => routePrevStep?.(),
  };

  return (
    <StepThemePreferences
      {...state}
      initialValues={state.themePreferenceValues}
      stepFooterProps={{ backButtonProps }}
      stepHeaderProps={{ backButtonProps }}
      subscription={state.subscription as Subscription}
    />
  );
};

export const MEMBERSHIP_STEP_THEME_PREFERENCES: MembershipStep = {
  component: MembershipStepThemePreferences,
  id: "membership-id-theme-preferences",
  slug: "theme-preferences",
};

export const MembershipStepThemePreferencesGift = ({
  onSubmit,
  onStateUpdate,
  routePrevStep,
  ...state
}: MembershipState) => {
  const { purchaseSubscription } = useContext(CheckoutContext);

  const [loading, setLoading] = useState(false);

  const backButtonProps = {
    onClick: () => routePrevStep?.(),
  };

  const handleSubmit: ThemePreferenceSubmit = async (values, formikHelpers) => {
    setLoading(true);

    const gsuResponse = await completeGSUQuiz({
      contentfulBoxImagesRaw: state.contentfulBoxImagesRaw,
      contentfulQuizModelParsed: state.contentfulQuizModelParsed,
    });

    onStateUpdate?.({ ...gsuResponse });

    const onPurchaseSuccess = async () => {
      onSubmit?.(values, formikHelpers);
    };

    const res = await purchaseSubscription?.(onPurchaseSuccess, {
      skipAddress: false,
      suppressAutoRoute: true,
    });

    if (isAPIError(res)) {
      setLoading(false);
      return;
    } else {
      trackGiftSubscriptionActivated();
      const subId = (res as any)?.[0]?.invoice?.items?.[0]?.object
        ?.subscriptionId;
      if (subId) {
        onStateUpdate?.({ subscription: { id: subId } });
      }
    }

    setLoading(false);
  };

  return loading ? (
    <StepLayoutLoadingScreen message="Activating Gift Subscription..." />
  ) : (
    <StepThemePreferences
      {...state}
      initialValues={state.themePreferenceValues}
      onSubmit={handleSubmit}
      stepFooterProps={{ backButtonProps }}
      stepHeaderProps={{ backButtonProps }}
      subscription={state.subscription as Subscription}
    />
  );
};

export const MEMBERSHIP_STEP_THEME_PREFERENCES_GIFT: MembershipStep = {
  ...MEMBERSHIP_STEP_THEME_PREFERENCES,
  component: MembershipStepThemePreferencesGift,
};

export default MEMBERSHIP_STEP_THEME_PREFERENCES;
